import { CCol } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'

const PreviewImage = ({ file, width, height, className }) => {
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    if (!file) {
      setPreview(null)
      return
    }

    const reader = new FileReader()
    reader.onload = () => setPreview(reader.result)
    reader.readAsDataURL(file)

    return () => {
      // cleanup
      setPreview(null)
    }
  }, [file])

  if (!file) return null

  return (
    <CCol className={className}>
      <img src={preview} alt="Preview" width={width} height={height} />
    </CCol>
  )
}

export default PreviewImage
